import { BotPlayerKind } from './BotPlayerKind'

export class BotPlayerKindOne extends BotPlayerKind {
  //
}
